import styled from 'styled-components';

import { BottomSheet as BottomSheetComponent } from '@xingternal/bottom-sheet';
import { Divider } from '@xingternal/divider';
import { Flag as FlagComponent } from '@xingternal/flag';
import { SingleSelect as SingleSelectComponent } from '@xingternal/menu';
import { Tag } from '@xingternal/tag';
import {
  spaceL,
  spaceM,
  spaceS,
  spaceXL,
  xdlColorDisabled,
  xdlColorText,
  xdlColorTextSecondary,
} from '@xingternal/tokens';
import { Headline, Meta } from '@xingternal/typography';

type Disabled = { $disabled?: boolean };

export const FiltersContainer = styled.div`
  padding-top: ${spaceL};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const FiltersTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const BSFiltersTextContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
`;

export const InlineFilter = styled.div<{ $spaced?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: ${({ $spaced }) => ($spaced ? 'space-between' : 'flex-start')};
  align-content: center;
`;

export const FilterHeadline = styled(Headline)<Disabled>`
  color: ${({ $disabled }) => ($disabled ? xdlColorDisabled : xdlColorText)};
  margin-bottom: ${spaceM};
`;

export const FilterDescription = styled(Meta)<Disabled>`
  max-width: calc(100% - ${spaceXL});
  color: ${({ $disabled }) => ($disabled ? xdlColorDisabled : xdlColorTextSecondary)};
`;

export const FilterDivider = styled(Divider)<{ $noMargin: boolean }>`
  margin-top: ${({ $noMargin }) => ($noMargin ? '0' : '20px')};
`;

export const MultiTagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spaceS};
`;

export const SingleTag = styled(Tag)`
  display: flex;
`;

export const SliderWrapper = styled.div`
  margin-top: 20px;
  padding-bottom: ${spaceL};
  padding-left: ${spaceM};
  padding-right: ${spaceM};
`;

export const Flag = styled(FlagComponent)`
  margin-right: ${spaceS};
`;

export const BannerWrapper = styled.div`
  margin-top: 20px;
`;

const ClickableElement = styled.button`
  border: none;
  background: none;
  width: 100%;
  padding: 0;
  text-align: left;
`;

export const ClickableFiltersContainer = styled(ClickableElement)<React.HTMLProps<HTMLButtonElement>>`
  padding-top: ${spaceL};
  padding-bottom: ${spaceL};
  cursor: ${({ onClick, disabled }) => (onClick && !disabled ? 'pointer' : 'default')};
`;

export const BottomSheet = styled(BottomSheetComponent)`
  & > div {
    padding-bottom: ${spaceM};
    padding-left: ${spaceL};
    padding-right: ${spaceL};
    padding-top: ${spaceM};
  }
`;

export const SingleSelect = styled(SingleSelectComponent)`
  div {
    width: 100%;
    justify-content: space-between;
  }
`;
